module.exports = __webpack_public_path__ + "assets/059c0270b08707cfd4fc41cd9ccd6eea.png";